const UrlList=[
    "https://web.prepladder.com/",
    "https://api.oneprep.com/",
]
export default UrlList;